import keyMirror from 'keymirror'

export const PO_MIN_LENGTH = 5

export const ProjectTabs = {
  submissions: 0,
  documents: 1,
  contractorInfo: 2,
  workPermit: 3,
}

export const PROJECT_TYPES = keyMirror({
  PO: null,
  CONTRACT: null,
})

export const PROJECT_TYPES_MAP = {
  PO: 'purchaseOrder',
  CONTRACT: 'contract',
}

export const PROJECT_FOLDER_STATUS = keyMirror({
  REVIEW: null,
  REJECT: null,
  APPROVE: null,
})
